import {concat, some, trim} from "lodash";

export const UPSTREAM_DELIM = ';UPSTREAM;';

// function formatOptionLabel(text) {
//   return text.replaceAll(/, /g, "\n   ");
// }

/**
 * 2025-06 Build the {value, label} object that is wanted by react-select.
 * Use the splitOn field of productAttribute, if it exists, to split long attributes into lines.
 *
 * @param choices
 * @param name
 * @param label
 * @param upstream
 * @param productAttribute
 * @returns {{label: string, value: null}[]}
 */
export function buildOptions({choices, name, label, upstream = "", productAttribute={}}) {
  let prompt = {value: null, label: `Select ${label || name}`};

  const splitOn = productAttribute?.splitOn;
  // let longForm = some(choices, c => ((c.l || c.v || '').length >= 50));

  let opts = choices.map(c => {
    // add the ;UPSTREAM=whatever suffix, so the values are unique every time
    let value = upstream ? `${c.v}${UPSTREAM_DELIM}${upstream}` : c.v;

    let label = c.l || c.v;

    if (splitOn) {
      // add some padding at the start of subsequent lines
      label = label.split(splitOn).join("\n   ");
    }

    return {value, label}
  });

  return concat([prompt], opts);
}
